import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, CircularProgress } from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import axios from '../../Configs/axiosInstance';
import { MAIN_URL } from '../../Configs/Urls';
import PatientDietView from './Patient-Diet-View';

// Thin routing wrapper around the (unchanged) PatientDietView component.
// It only resolves the URL's :id into the props PatientDietView already
// expects (planId + the week-range string) — none of PatientDietView's
// own fetch/PDF/logic is touched.
export default function PatientDietPlanViewPage() {
  const { id: planId } = useParams();
  const navigate = useNavigate();

  const [selectedWeekdefault, setSelectedWeekdefault] = useState("");
  const [weight, setWeight] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!planId) return;

    setLoading(true);
    axios
      .get(`${MAIN_URL}patientdietplans/${planId}`)
      .then((response) => {
        const { weekDateStart, weekDateEnd, weight } = response.data.DietPlan;
        setSelectedWeekdefault(`${weekDateStart} - ${weekDateEnd}`);
        setWeight(weight);
      })
      .finally(() => setLoading(false));
  }, [planId]);

  const goBack = () => navigate('/patient-diet');

  if (loading) {
    return (
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Button
        startIcon={<ArrowBackRoundedIcon />}
        onClick={goBack}
        sx={{ mb: 2, textTransform: 'none', fontWeight: 600 }}
      >
        Back to Diet Plans List
      </Button>

      <PatientDietView
        showDownload
        showPatientInfo
        planId={planId}
        selectedWeekdefault={selectedWeekdefault}
        weight={weight}
        onCloseForm={goBack}
      />
    </Box>
  );
}
